import { _defineProperty } from "@slyte/core/src/lyte-utils";
import {Route} from "../../../node_modules/@slyte/router/index.js";
let DaterangepickerComp;

class Daterangepicker extends Route {
    render() {
        return { outlet: '#zcatcomponent', component: DaterangepickerComp };
    }

    static actions(arg1) {
        return Object.assign(super.actions({

        }), arg1);
    }

    _() {
        _;
    }

    getRequirements() {
        arguments[1].push(import(
            /* webpackChunkName: "components/javascript/zcat-components/daterangepicker-comp" */
            "../../../components/javascript/zcat-components/daterangepicker-comp"
        ).then(function(res) {
            DaterangepickerComp = res.DaterangepickerComp;
        }));

        
;
    }
}

export {Daterangepicker};

